import { render, staticRenderFns } from "./SiteNavLectorPatrocinadores.vue?vue&type=template&id=0dbc5e92&"
import script from "./SiteNavLectorPatrocinadores.vue?vue&type=script&lang=js&"
export * from "./SiteNavLectorPatrocinadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports